import { render } from "./CategoriasProd.vue?vue&type=template&id=7b968614&scoped=true"
import script from "./CategoriasProd.vue?vue&type=script&lang=js"
export * from "./CategoriasProd.vue?vue&type=script&lang=js"

import "./CategoriasProd.vue?vue&type=style&index=0&id=7b968614&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b968614"]])

export default __exports__